function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getUrlWithColor } from "services/community/cloudinary-service";
import AssetComponent from "components/core/asset/asset-component";
import { StyledMobileTabNavButtonWithIcon } from "./mobile-tab-nav-button-with-icon.scss";
const DEFAULT_ICON_SIZE = 24;
const getIconAssetProps = ({ icon })=>({
        image: {
            src: getUrlWithColor({
                url: icon
            })
        }
    });
const MobileTabNavButtonWithIcon = ({ label, icon, isSelected = false, selectedIconBackgroundColor })=>{
    return /*#__PURE__*/ _jsxs(StyledMobileTabNavButtonWithIcon, {
        className: "tab-nav-button-with-icon",
        isSelected: isSelected,
        selectedIconBackgroundColor: selectedIconBackgroundColor,
        role: "tab",
        "aria-selected": isSelected,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "icon-container",
                children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread_props(_object_spread({}, getIconAssetProps({
                    icon
                })), {
                    width: `${DEFAULT_ICON_SIZE}px`,
                    height: `${DEFAULT_ICON_SIZE}px`
                }))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "label-container",
                dangerouslySetInnerHTML: {
                    __html: label
                }
            })
        ]
    });
};
export default MobileTabNavButtonWithIcon;
